/**
 * Uygulamaya ait **tüm** tarayıcı-depo anahtarları tek bir ön ekle yazılır (062 research D7a).
 *
 * <p>Gerekçe: kullanıcı/persona geçişinde "sıfır artık" güvencesi (FR-010a) elle tutulan bir anahtar
 * listesiyle verilemez — yarın eklenen bir liste ekranı listeye eklenmezse eski kullanıcının filtresi
 * yeni oturumda yaşar. Ön ek + ön ek taraması kuralı **kendiliğinden kapsayıcı** kılar: yeni bir anahtar
 * eklemek için tek koşul `appStorageKey()` kullanmaktır, temizlik kodu değişmez.
 *
 * <p>**İstisna yoktur** — oturuma bağlı olmayan tercihler (ör. sidebar) de ön ek alır; böylece
 * "hangi anahtar ön ek alır?" sorusu ileride tekrar sorulmaz.
 */
export const APP_STORAGE_PREFIX = 'ceosuite:'

/**
 * Ön ekten önce kullanılmış anahtar adları. Geçiş dönemi için temizlikte **de** silinirler; aksi hâlde
 * göç öncesinde yazılmış bir filtre kaydı yeni oturumlarda kalıcı olarak yaşardı. Yeni kod bu adları
 * **kullanmaz** (yalnız siler).
 */
const LEGACY_STORAGE_KEYS = ['activity-list-view', 'tk-list-view', 'ceo.sidebar.collapsed'] as const

/** Uygulama ön ekli depo anahtarı üretir (ör. `activity-list-view` → `ceosuite:activity-list-view`). */
export function appStorageKey(name: string): string {
  return `${APP_STORAGE_PREFIX}${name}`
}

/**
 * Verilen depodaki uygulama ön ekli **tüm** anahtarları (+ göç öncesi eski adları) siler. Depoya
 * erişilemiyorsa (private mode vb.) sessizce geçer — temizlik best-effort'tur.
 */
export function clearAppStorageKeys(store: Storage): void {
  try {
    // Silme sırasında index'ler kaydığından anahtarlar ÖNCE toplanır, sonra silinir.
    const doomed: string[] = []
    for (let i = 0; i < store.length; i++) {
      const key = store.key(i)
      if (key != null && key.startsWith(APP_STORAGE_PREFIX)) {
        doomed.push(key)
      }
    }
    doomed.forEach((key) => store.removeItem(key))
    LEGACY_STORAGE_KEYS.forEach((key) => store.removeItem(key))
  } catch {
    /* depo erişilemiyorsa yoksay (temizlik best-effort) */
  }
}
